import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme }) => ({
    // Em telas grandes mantém compensação do AppBar
    height: `calc(100% - 48px)`,
    [theme.breakpoints.down('sm')]: {
        // No mobile não há AppBar visível, então ocupa 100%
        height: '100%'
    },
    display: 'grid',
    gridTemplateRows: '0px 1fr'
}));

export default TicketAdvancedLayout;